import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { LOGO } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    googleLogin(sessionId)
      .then((user) => {
        toast.success(`Welcome${user.name ? ", " + user.name.split(" ")[0] : ""}`);
        navigate(user.role === "admin" ? "/admin" : "/account", { replace: true, state: { user } });
      })
      .catch(() => {
        toast.error("Google sign-in failed — please try again");
        navigate("/auth", { replace: true });
      });
  }, []);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <img src={LOGO} alt="BTMEDU" className="h-10 w-auto animate-pulse" />
      <p className="text-sm text-slate-500 font-medium">Signing you in with Google…</p>
    </div>
  );
}
